import Logo from "../assets/munch box 2.png";
interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner({
  message = "Loading...",
}: LoadingSpinnerProps) {
  return (
    <div className="fixed inset-0 bg-[#11395D] flex items-center justify-center z-50">
      <div className="flex flex-col items-center justify-center">
        {/* Logo placeholder - you can replace this with your actual logo */}
        <div className="w-[400px] h-34 mb-4  rounded-full flex items-center justify-center animate-pulse">
          <img src={Logo} alt="" />
        </div>
      </div>
    </div>
  );
}
